exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.image[data-v-7facd7f9] {\n    margin: 10px 0;\n    margin-right: 10px;\n}\nimg[data-v-7facd7f9] {\n    background-position: center;\n    background-size: cover;\n}\n.hoverbtn[data-v-7facd7f9] {\n    opacity: 0.3;\n}\n.hoverbtn[data-v-7facd7f9]:hover {\n    opacity: 1;\n    color: tomato;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7facd7f9","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/Uploader.vue
// module id = 7Mz+
// module chunks = 142